import React from "react";
import { useNavigate } from "react-router-dom";
import LoanSteps from "./Loansteps";
import CallToAction from "./CallToAction";

const NonFundBasedLendingInfo = () => {
    const navigate = useNavigate();

    return (
        <>
            <div className="other-pages-main-section non-fund-based-lending-fin">
                <h2 className="other-pages-title">Non-Fund Based Lending</h2>
                <p>
                    <span onClick={() => navigate("/")} style={{ cursor: "pointer" }}>Home</span> /
                    <span onClick={() => navigate("/non-fund-based-lending-mumbai-thane-palghar-maharashtra-delhi-india")} style={{ cursor: "pointer" }}>Non-Fund Based Lending</span>
                </p>
            </div>

            <div className="info-loan-card-smco">
                <h2 className="info-loan-title-smco">What is Non-Fund Based Lending?</h2>

                <p className="info-loan-description-smco">
                    Non-fund based lending involves financial instruments that do not require the actual disbursement of funds but provide credit support or guarantees to facilitate business transactions. These include Letters of Credit (LC), Bank Guarantees (BG), and other contingent liabilities that enhance a business's credibility and ability to engage in trade and large-scale contracts.
                    <br /><br />
                    Unlike fund-based lending where money changes hands, non-fund based facilities act as a promise or assurance from the bank, enabling businesses to secure deals, import goods, or undertake projects without tying up their own capital. This form of lending is crucial for businesses involved in international trade, government contracts, and large procurement activities.
                    <br /><br />
                    At KRS FinSolutions, we specialize in arranging non-fund based lending solutions that provide the necessary financial backing for your business expansion and operational needs without impacting your cash flow.
                </p>

                <div className="info-section-smco">
                    <h3 className="info-section-title-smco">Types of Non-Fund Based Lending</h3>
                    <ul className="info-feature-list-smco">
                        <li><strong>Letters of Credit (LC):</strong> Bank-issued documents guaranteeing payment to suppliers upon fulfillment of specified conditions, commonly used in international trade.</li>
                        <li><strong>Bank Guarantees (BG):</strong> Written assurances from banks to pay a specified amount if the borrower fails to fulfill contractual obligations.</li>
                        <li><strong>Performance Guarantees:</strong> Assurances that contractual obligations will be met, often required for project-based work.</li>
                        <li><strong>Advance Payment Guarantees:</strong> Protection for buyers who make advance payments to suppliers.</li>
                        <li><strong>Bid Bonds:</strong> Guarantees submitted with tenders to ensure serious participation in bidding processes.</li>
                    </ul>
                </div>

                <div className="info-section-smco">
                    <h3 className="info-section-title-smco">Key Features</h3>
                    <ul className="info-feature-list-smco">
                        <li><strong>No fund outflow:</strong> Credit support without actual disbursement of money.</li>
                        <li><strong>Low cost:</strong> Commission-based pricing, typically 0.5% to 2% of the guarantee amount.</li>
                        <li><strong>Flexible terms:</strong> Validity periods aligned with contract durations.</li>
                        <li><strong>Quick processing:</strong> Faster approval compared to fund-based facilities.</li>
                        <li><strong>Enhanced credibility:</strong> Bank backing improves business reputation and negotiation power.</li>
                    </ul>
                </div>

                <div className="info-section-smco">
                    <h3 className="info-section-title-smco">Benefits of Non-Fund Based Lending</h3>
                    <ul className="info-benefits-list-smco">
                        <li><strong>Trade facilitation:</strong> Enables smooth import-export operations and international business expansion.</li>
                        <li><strong>Cash preservation:</strong> Maintains liquidity by avoiding upfront payments or collateral requirements.</li>
                        <li><strong>Risk mitigation:</strong> Provides security to counterparties, reducing transaction risks.</li>
                        <li><strong>Competitive advantage:</strong> Enhances bidding capabilities for large contracts and projects.</li>
                        <li><strong>Cost-effective:</strong> Lower costs compared to maintaining cash reserves for contingencies.</li>
                    </ul>
                </div>

                <div className="info-section-smco">
                    <h3 className="info-section-title-smco">Our Services</h3>
                    <p>
                        KRS FinSolutions offers comprehensive support for non-fund based lending requirements:
                        <br />• <strong>Requirement analysis:</strong> Understanding your trade and contractual needs to recommend appropriate instruments.
                        <br />• <strong>Bank coordination:</strong> Liaising with banks and financial institutions for guarantee issuance.
                        <br />• <strong>Documentation:</strong> Preparing and submitting necessary applications and supporting documents.
                        <br />• <strong>Negotiation:</strong> Securing favorable terms and competitive commission rates.
                        <br />• <strong>Management:</strong> Ongoing support for renewals, amendments, and claim settlements if needed.
                    </p>
                </div>
            </div>

            <LoanSteps />
            <CallToAction />
        </>
    );
};

export default NonFundBasedLendingInfo;
